export class Product {
    private _id: string;
    private _isbn: string | null;
    private _eancode: string;
    private _logisticCode: string;
    private _name: string;
    private _description: string;
    private _condition: string;
    private _kind: string;
    private _supplyType: string;
    private _purchaseDiscount: number;
    private _publisher: string;
    private _publishDate: string;
    private _displayStock: number;
    private _printStatus: string;
    private _price: Price;

    constructor(data: {
        id: string;
        isbn: string | null;
        eancode: string;
        logisticCode: string;
        name: string;
        description: string;
        condition: string;
        kind: string;
        supplyType: string;
        purchaseDiscount: number;
        publisher: string;
        publishDate: string;
        displayStock: number;
        printStatus: string;
        price: Price;
    }) {
        this._id = data.id;
        this._isbn = data.isbn;
        this._eancode = data.eancode;
        this._logisticCode = data.logisticCode;
        this._name = data.name;
        this._description = data.description;
        this._condition = data.condition;
        this._kind = data.kind;
        this._supplyType = data.supplyType;
        this._purchaseDiscount = data.purchaseDiscount;
        this._publisher = data.publisher;
        this._publishDate = data.publishDate;
        this._displayStock = data.displayStock;
        this._printStatus = data.printStatus;
        this._price = new Price(data.price);
    }

    // Getters
    get id(): string {
        return this._id;
    }

    set id(value: string) {
        this._id = value;
    }

    get isbn(): string | null {
        return this._isbn;
    }

    set isbn(value: string | null) {
        this._isbn = value;
    }

    get eancode(): string {
        return this._eancode;
    }

    set eancode(value: string) {
        this._eancode = value;
    }

    get logisticCode(): string {
        return this._logisticCode;
    }

    set logisticCode(value: string) {
        this._logisticCode = value;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get description(): string {
        return this._description;
    }

    set description(value: string) {
        this._description = value;
    }

    get condition(): string {
        return this._condition;
    }

    set condition(value: string) {
        this._condition = value;
    }

    get kind(): string {
        return this._kind;
    }

    set kind(value: string) {
        this._kind = value;
    }

    get supplyType(): string {
        return this._supplyType;
    }

    set supplyType(value: string) {
        this._supplyType = value;
    }

    get purchaseDiscount(): number {
        return this._purchaseDiscount;
    }

    set purchaseDiscount(value: number) {
        this._purchaseDiscount = value;
    }

    get publisher(): string {
        return this._publisher;
    }

    set publisher(value: string) {
        this._publisher = value;
    }

    get publishDate(): string {
        if (!this._publishDate || this._publishDate.length < 10) {
            return '';
        }

        return this._publishDate.substring(0, 10);
    }

    set publishDate(value: string) {
        this._publishDate = value;
    }

    get displayStock(): number {
        return this._displayStock;
    }

    set displayStock(value: number) {
        this._displayStock = value;
    }

    get printStatus(): string {
        return this._printStatus;
    }

    set printStatus(value: string) {
        this._printStatus = value;
    }

    get price(): Price {
        return this._price;
    }

    set price(value: Price) {
        this._price = value;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static fromJson(json: Record<string, any>): Product {
        return new Product({
            id: json.book_data.prodId,
            isbn: json.book_data.isbn,
            eancode: json.book_data.eanCode,
            logisticCode: '',
            name: json.book_data.titleMain,
            description: '',
            condition: '',
            kind: '',
            supplyType: '',
            purchaseDiscount: 0,
            publisher: '',
            publishDate: '',
            displayStock: 0,
            printStatus: '',
            price: Price.fromJson(json.book_data)
        });
    }


    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public toJson(): Record<string, any> {
        return {
            id: this.id,
            isbn: this.isbn,
            eancode: this.eancode,
            logistic_code: this.logisticCode,
            name: this.name,
            description: this.description,
            condition: this.condition,
            kind: this.kind,
            supply_type: this.supplyType,
            purchase_discount: this.purchaseDiscount,
            publisher: this.publisher,
            publsih_date: this.publishDate,
            display_stock: this.displayStock,
            print_status: this.printStatus,
            price: this.price.toJson()
        };
    }
}

export class Price {
    private _listPrice: number;
    private _specialPrice: number;
    private _salePrice: number;
    private _saleDiscount: number;
    private _wholesalePrice: number;

    constructor(data: {
        listPrice: number;
        specialPrice: number;
        salePrice: number;
        saleDiscount: number;
        wholesalePrice: number;
    }) {
        this._listPrice = data.listPrice;
        this._specialPrice = data.specialPrice;
        this._salePrice = data.salePrice;
        this._saleDiscount = data.saleDiscount;
        this._wholesalePrice = data.wholesalePrice;
    }

    // Getters
    get listPrice(): number {
        return this._listPrice;
    }

    set listPrice(value: number) {
        this._listPrice = value;
    }

    get specialPrice(): number {
        return this._specialPrice;
    }

    set specialPrice(value: number) {
        this._specialPrice = value;
    }

    get salePrice(): number {
        return this._salePrice;
    }

    set salePrice(value: number) {
        this._salePrice = value;
    }

    get saleDiscount(): number {
        return this._saleDiscount
    }

    set saleDiscount(value: number) {
        this._saleDiscount = value;
    }

    get wholesalePrice(): number {
        return this._wholesalePrice;
    }

    set wholesalePrice(value: number) {
        this._wholesalePrice = value;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static fromJson(json: Record<string, any>) {
        return new Price({
            listPrice: json.listPrice,
            specialPrice: json.specialPrice,
            salePrice: json.salePrice,
            saleDiscount: json.saleDisc,
            wholesalePrice: json.salePrice
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public toJson(): Record<string, any> {
        return {
            list_price: this.listPrice,
            special_price: this.specialPrice,
            sale_price: this.salePrice,
            wholesale_price: this.wholesalePrice
        };
    }
}


export default Product;